import React from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { useVermins } from 'src/stores'
import styles from './List.module.scss';

export interface ItemProps {
  path: string;
  title: string;
  children: React.ReactNode;
}

export const Item: React.FC<ItemProps> = ({ path, title, children }) => {
  const navigate = useNavigate();

  const deleteVermins = useVermins(state => state.deleteVermins);

  function handlePages(data: string) {
    navigate(data);
    deleteVermins();
  }

  return (
    <li className={styles.item}>
      <button onClick={() => handlePages(path)} className={styles.link}>
        {children}
        <span className={styles.itemText}>{title}</span>
      </button>
    </li>
  );
};
